import React from 'react';

// Clasifica el entorno según el host verificado por TLS.
// Preproducción: prewww*.aeat.es (certificado *.aeat.es)
// Producción: *.agenciatributaria.gob.es (certificado agenciatributaria.gob.es)
const clasificarEntorno = (host) => {
	if (!host) return { texto: 'Desconocido', color: '#6c7086' };
	if (/^prewww\d*\.aeat\.es$/i.test(host)) return { texto: 'PREPRODUCCIÓN (pruebas)', color: '#a6e3a1' };
	if (/(^|\.)agenciatributaria\.gob\.es$/i.test(host)) return { texto: 'PRODUCCIÓN (real)', color: '#f38ba8' };
	return { texto: 'No reconocido', color: '#f9e2af' };
};

const Fila = ({ etiqueta, valor, mono }) => (
	<div style={{ display: 'flex', gap: '10px', fontSize: '12px', lineHeight: '1.6' }}>
		<span style={{ color: '#6c7086', minWidth: '150px' }}>{etiqueta}</span>
		<span style={{ color: '#cdd6f4', fontFamily: mono ? 'monospace' : 'inherit', wordBreak: 'break-all' }}>{valor || '—'}</span>
	</div>
);

// Datos del certificado TLS que presentó el servidor de la AEAT al recibir el envío
const ServidorAeatInfo = ({ servidor }) => {
	if (!servidor) {
		return (
			<div style={{ color: '#6c7086', fontSize: '12px', padding: '10px 12px', border: '1px dashed #45475a', borderRadius: '8px', marginBottom: '14px' }}>
				Sin datos del servidor AEAT: este envío se procesó antes de registrar el certificado TLS, o en modo test sin certificado.
			</div>
		);
	}

	const entorno = clasificarEntorno(servidor.host);

	return (
		<div style={{ border: '1px solid #45475a', borderRadius: '8px', padding: '10px 12px', marginBottom: '14px', background: '#181825' }}>
			<div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
				<span style={{ fontWeight: 700, color: '#cdd6f4', fontSize: '13px' }}>Servidor AEAT (certificado TLS)</span>
				<span style={{ marginLeft: 'auto', fontWeight: 700, fontSize: '12px', color: '#1e1e2e', background: entorno.color, borderRadius: '6px', padding: '2px 10px' }}>
					{entorno.texto}
				</span>
			</div>
			<Fila etiqueta="Host" valor={servidor.host} mono />
			<Fila etiqueta="IP" valor={servidor.ip} mono />
			<Fila etiqueta="Certificado (CN)" valor={servidor.sujeto} mono />
			<Fila etiqueta="Organización" valor={servidor.organizacion} />
			<Fila etiqueta="Nombres válidos" valor={servidor.nombresAlternativos} mono />
			<Fila etiqueta="Emitido por" valor={servidor.emisor} />
			<Fila etiqueta="Validez" valor={servidor.validoDesde && servidor.validoHasta ? `${servidor.validoDesde} → ${servidor.validoHasta}` : null} />
			<Fila etiqueta="Huella SHA-256" valor={servidor.huellaSha256} mono />
			<Fila etiqueta="Conexión" valor={servidor.fechaConexion ? new Date(servidor.fechaConexion).toLocaleString('es-ES') : null} />
		</div>
	);
};

export default ServidorAeatInfo;
